import React from "react";
import { FormSelect } from "./FormInput.js";
function DatePickerDropdown({ value, options, onChange }) {
  function handleValueChange(e) {
    if (onChange) {
      const syntheticEvent = {
        target: {
          value: e.target.value
        }
      };
      onChange(syntheticEvent);
    }
  }
  return /* @__PURE__ */ React.createElement(
    FormSelect,
    {
      value,
      options,
      onChange: handleValueChange,
      hasBottomSpacing: false,
      fullWidth: false,
      isCompareOptionsAvailable: false,
      alignLeft: true
    }
  );
}
export {
  DatePickerDropdown
};
//# sourceMappingURL=DatePickerDropdown.js.map
